import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CreditCardComponent } from '../../shared/credit-card/credit-card.component';
import { PaymentMethodsComponent } from '../../shared/billing-view/payment-methods/payment-methods.component';
import { MonthSelectComponent } from "../../shared/month-select/month-select.component";
import { ICreditCardInfo, IPackagePrice, LocalStorageList, MY_ACCOUNT_CONFIG, PackagePriceService, PaymentMethodsService, PersistenceService } from '../../../../public-api';
import { PreSuspendedService } from '../../../services/pre-suspended/pre-suspended.service';
import { FormGroup } from '@angular/forms';
import { LoadingService, PopUpService } from 'lib-shared';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-reactivate-account-page',
  standalone: true,
  imports: [
    CreditCardComponent,
    PaymentMethodsComponent,
    TranslocoModule,
    MonthSelectComponent
],
  templateUrl: './reactivate-account-page.component.html',
  styleUrl: './reactivate-account-page.component.scss',
})
export class ReactivateAccountPageComponent {
  private paymentMethodsService = inject(PaymentMethodsService);
  private preSuspendedService = inject(PreSuspendedService);
  private popUpService = inject(PopUpService);
  private loadingService = inject(LoadingService);
  private vNumPackagePriceService = inject(PackagePriceService);
  private persistenceService = inject(PersistenceService);
  private config = inject(MY_ACCOUNT_CONFIG);
  primaryColor: string = this.config.theme.primaryColor;

  showCreditCard: boolean = false;
  savedCards: ICreditCardInfo[] = [];
  paymentID: number = 0;
  preSuspendedData: any = null;

  isNewMethod: boolean = false;
  isPrimary: boolean = false;
  keepCard: boolean = true;

  packageData: any;
  currentActiveDuration: number = 1;
  selectedDuration: number = 1;
  renewalPackageID: number = 0;

  creditCardForm = this.paymentMethodsService.paymentMethodsForm.get(
    'creditCardFrom'
  ) as FormGroup;
  addressCardForm = this.paymentMethodsService.paymentMethodsForm.get(
    'addressCardForm'
  ) as FormGroup;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.getAllSavedCards();

    this.route.queryParams.subscribe((params) => {
      this.preSuspendedData = {
        transactionID: params['transactionId'],
        transactionAmount: params['amount'],
      };
    });

    this.getPackagePrice();
  }

  async getPackagePrice() {
    try {
      const res =
        await this.vNumPackagePriceService.getMyAccountPackagePrice<IPackagePrice>();

      if (res.isSuccessful && res.result) {
        this.packageData = res.result;

        this.currentActiveDuration = res.result.monthsInterval;
        this.selectedDuration = res.result.monthsInterval;

        // this.calculateInitialPrice();
      }
    } catch (error) {
      console.error(error);
    }
  }

  async reactivateAccount() {
    this.loadingService.setLoading(true);

    let jsonData;

    const {
      cardNumber,
      cardHolder,
      cardExpirationMM,
      cardExpirationYY,
      cardCVV,
      isPrimaryCard,
    } = this.creditCardForm.value;

    const { city, state, zipCode, address, country } =
      this.addressCardForm.value;

    if (this.isNewMethod) {
      jsonData = {
        CreditCardNumber: cardNumber,
        CardHolder: cardHolder,
        ExpirationMonth: Number(cardExpirationMM),
        ExpirationYear: Number(cardExpirationYY),
        SecurityCode: cardCVV,
        IsPrimary: isPrimaryCard ? 1 : 0,
        City: city,
        State: state,
        Zip: zipCode,
        Address: address,
        CountryNumber: country,
        IsSaveCard: 1, // always true in this scenario
        RenewalPackageID: this.renewalPackageID
      };
    } else {
      jsonData = {
        PaymentId: this.paymentID,
        RenewalPackageID: this.renewalPackageID
      };
    }

    try {
      const res = await this.preSuspendedService.submitSuspendedPayment(
        jsonData
      );
      if (res.response_code === 200) {
        this.persistenceService.removeData(LocalStorageList.suspended);

        document.location.href = '/login';
      } else {
        this.popUpService.openPopUp('error');
      }
    } catch (error) {
      console.error(error);
      
      if (error.error.response_code === 530 || error.error.response_code === 531) {
        this.popUpService.openPopUp('recaptcha');
        this.loadingService.setLoading(false);
      } else {
        this.popUpService.openPopUp('server-error');
      }
    } finally {
      this.loadingService.setLoading(false);
    }
  }

  onSelectedPaymentMethod(paymentId: number) {
    this.paymentID = paymentId;
  }

  onAddCreditFromNewCard() {
    this.isNewMethod = true;
    this.reactivateAccount();
  }

  onDurationSelected(event: { months: number; renewalPackageID?: number }) {
    this.selectedDuration = event.months;
    this.renewalPackageID = event.renewalPackageID || 0;
    // Buscar la opción seleccionada para obtener el precio correcto
    // const selectedOption = this.packageData.discounts.find(
    //   (d: any) => d.intervalMonths === event.months
    // ) || { price: this.packageData.price };

    // const packagePrice = selectedOption.price * event.months;
  }

  async getAllSavedCards() {
    try {
      const res = await this.paymentMethodsService.getAllSavedCreditCards<
        ICreditCardInfo[]
      >();

      if (res.isSuccessful && res.result) {
        this.savedCards = res.result;
      }
    } catch (error) {
      console.error(error);
    }
  }
}
